import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';

import styles from './Content.module.css';

const cx = classNames.bind(styles);

export default class Content extends PureComponent {
  static propTypes = {
    borderTop: PropTypes.bool,
    borderBottom: PropTypes.bool,
    children: PropTypes.node.isRequired,
    maximize: PropTypes.bool,
    indentTop: PropTypes.bool,
    indentBottom: PropTypes.bool,
    paddingXOff: PropTypes.bool,
    isRegistration: PropTypes.bool
  };

  static defaultProps = {
    borderTop: false,
    borderBottom: false,
    children: undefined,
    maximize: false,
    indentTop: true,
    indentBottom: true,
    paddingXOff: false,
    isRegistration: false
  };

  render() {
    return (
      <section
        className={cx('content', {
          content_borderTop: this.props.borderTop,
          content_borderBottom : this.props.borderBottom ,
          content_indentTop: this.props.indentTop,
          content_indentBottom: this.props.indentBottom,
          content_paddingXOff: this.props.paddingXOff,
          content_maximize: this.props.maximize,
          content_registration: this.props.isRegistration
        })}
      >
        {this.props.children}
      </section>
    );
  }
}
